/* Loads the Meta Pixel base script once */
export const loadPixelBase = () => {
  if (document.getElementById('fb-pixel-base')) return;

  const s = document.createElement('script');
  s.id = 'fb-pixel-base';
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);

  if (!window.fbq) {
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    window.fbq = n;
  }
}; 